<div class="row mb-3 mt-lg-2 justify-content-md-center">
    <div class="col-xl-6 col-lg-12 mb-3">

        <mdb-card>

            <mdb-card-header class="info-color white-text text-center py-4">
                <h5>
                    <strong>Submit Feedback</strong>
                </h5>
            </mdb-card-header>

            <!--Card content-->
            <mdb-card-body>

                <div *ngIf="vm.workingText">
                    <span>{{vm.workingText}}</span>
                </div>

                <div *ngIf="!vm.workingText">
                    <div *ngIf="vm.successText">
                        <span>{{vm.successText}}</span>
                        <button mdbBtn color="info" outline="true" rounded="true" block="true"
                            class="z-depth-0 my-4 waves-effect" mdbWavesEffect type="button" (click)="addAnother()">Add
                            Another</button>
                    </div>

                    <div *ngIf="vm.errorText">
                        <span class="text-danger">{{vm.errorText}}</span>
                        <button mdbBtn color="danger" outline="true" rounded="true" block="true"
                            class="z-depth-0 my-4 waves-effect" mdbWavesEffect type="button" (click)="tryAgain()">Try
                            AGain</button>
                    </div>

                    <div *ngIf="!vm.successText && !vm.errorText">
                        <!-- Form -->
                        <form class="text-center" style="color: #757575;">

                            <!-- Name -->
                            <div class="md-form mt-3">
                                <input type="text" id="feedback-name" class="form-control" mdbInput
                                    [(ngModel)]="vm.userName" [ngModelOptions]="{standalone: true}">
                                <label for="feedback-name">Name</label>
                            </div>

                            <!-- res number -->
                            <div class="md-form">
                                <input type="text" id="feedback-res" class="form-control" mdbInput
                                    [(ngModel)]="vm.resNumber" [ngModelOptions]="{standalone: true}">
                                <label for="feedback-res">Res Number</label>
                            </div>

                            <!-- subject -->
                            <div class="md-form">
                                <input type="text" id="feedback-subject" class="form-control" mdbInput
                                    [(ngModel)]="vm.subject" [ngModelOptions]="{standalone: true}">
                                <label for="feedback-subject">Subject</label>
                            </div>

                            <!-- body -->
                            <div class="md-form">
                                <textarea type="text" id="feedback-body"
                                    class="md-textarea md-textarea-auto form-control" mdbInput [(ngModel)]="vm.body"
                                    [ngModelOptions]="{standalone: true}"></textarea>
                                <label for="feedback-body">Body</label>
                            </div>

                            <!-- Sign in button -->
                            <button mdbBtn color="info" outline="true" rounded="true" block="true"
                                class="z-depth-0 my-4 waves-effect" mdbWavesEffect type="submit"
                                (click)="submit()">Submit</button>

                        </form>
                        <!-- Form -->


                    </div>
                </div>

            </mdb-card-body>

        </mdb-card>
    </div>
</div>